import axios from "axios";
import { reactive, ref } from "vue";
import { loading, errors, toast, meta, loadingBtn, remove } from "./shared";

export default function useFailureReason(navigation) {
  const { route, router } = navigation;
  const initFailureReason = {status: 1};
  const failureReasons = ref([]);
  const failureReason = reactive({...initFailureReason});
  const getFailureReasons = async (query = {}) => {
    try {
      errors.value = "";
      loading.value = true;
      const search = isObjectNotEmpty(query)
        ? "?" + new URLSearchParams(query).toString()
        : "";
      let response = await axios.get("user/failure-reason" + search);
      loading.value = false;
      failureReasons.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const getFailureReason = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/failure-reason/" + route.params.id);
      loading.value = false;
      Object.assign(failureReason, response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeFailureReason = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      let response = await axios.post("user/failure-reason", failureReason);
      loadingBtn.value = false;
      toast.success(response.data.message);
      document.getElementById("add-edit-modal").checked = false;
      getFailureReasons();
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const updateFailureReason = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      let response = await axios.put(
        "user/failure-reason/" + failureReason.id,
        failureReason
      );
      const index = failureReasons.value.findIndex(
        (item) => item.id === failureReason.id
      );
      failureReasons.value[index] = response.data.data;
      loadingBtn.value = false;
      toast.success(response.data.message);
      document.getElementById("add-edit-modal").checked = false;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const removeFailureReason = async () => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/failure-reason/" + failureReason.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById("delete-modal").checked = false;
      getFailureReasons(route.query);
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

   const clearFailureReason = () => initObject(failureReason,initFailureReason);

  return {
    failureReasons,
    failureReason,
    clearFailureReason,
    getFailureReasons,
    getFailureReason,
    storeFailureReason,
    updateFailureReason,
    removeFailureReason,
  };
}
